import Text from '$tablet-app/src/app/components/Text';
import { Button } from '@akin-home/buttons/native';
import { DrawerHeaderProps } from '@react-navigation/drawer';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { spacing } from '../../../theme';
import Spacer from '$tablet-app/src/app/components/Spacer';

const SettingsDrawerHeader = (props: DrawerHeaderProps) => {
  const { navigation, route, options } = props;

  const title =
    typeof options.headerTitle === 'string' ? options.headerTitle : route.name;

  const showOpenDrawerButton = options.drawerType !== 'permanent';

  return (
    <View style={styles.container}>
      {showOpenDrawerButton ? (
        <Button
          variant="text"
          iconSize={22}
          icon={'bars'}
          onPress={() => navigation.openDrawer()}
          style={styles.drawerButton}
        />
      ) : (
        <Spacer width="10px" />
      )}

      <Text variant="h2" weight="semibold" style={styles.title}>
        {title}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: 'white',
    flexDirection: 'row',
    paddingVertical: spacing[3],
  },
  drawerButton: {
    backgroundColor: 'white',
    borderColor: 'green',
    marginHorizontal: spacing[3],
  },
  title: {
    textAlign: 'center',
    textAlignVertical: 'center',
    marginVertical: 'auto',
  },
});

export default SettingsDrawerHeader;
